import { RouteObject } from "react-router-dom";
import DashboardPage from "./dashboard-page";
import ReportsTimePage from "./reports-time/reports-time-page";
import ReportsMerchantPage from "./reports-merchant/reports-merchant-page";
import ReportsCustomerPage from "./reports-customer/reports-customer-page";
import ReportsProcessorPage from "./reports-processor/reports-processor-page";
import ReportsStatusPage from "./reports-status/reports-status-page";
import ReportsCardBrandPage from "./reports-card-brand/reports-card-brand-page";
import ReportsCommissionPage from "./reports-commission/reports-commission-page";
import MerchantGuard from "../merchant-guard";
import ReportDailyProcessing from "./reports-daily-processing/reports-daily-processing";
import GenerateSettlementPage from "./generate-settlement/generate-settlement-page";
import GenerateRRReleasePage from "./generate-rr-release/generate-rr-release-page";

const dashboardRouter: RouteObject[] = [
    {
        path: '',
        element: <DashboardPage />
    },
    {
        path: 'reports-time',
        element: <ReportsTimePage />
    },
    {
        path: 'reports-merchant',
        element: <MerchantGuard><ReportsMerchantPage /></MerchantGuard>
    },
    {
        path: 'generate-settlement',
        element: <MerchantGuard><GenerateSettlementPage /></MerchantGuard>
    },
    {
        path: 'generate-rr-release',
        element: <MerchantGuard><GenerateRRReleasePage/></MerchantGuard>,
    },
    {
        path: 'reports-customer',
        element: <MerchantGuard><ReportsCustomerPage /></MerchantGuard>
    },
    {
        path: 'reports-processor',
        element: <ReportsProcessorPage />
    },
    {
        path: 'reports-status',
        element: <ReportsStatusPage />
    },
    {
        path: 'reports-card-brand',
        element: <ReportsCardBrandPage />
    },
    {
        path: 'reports-daily-processing',
        element: <ReportDailyProcessing />
    }
    // {
    //     path: 'reports-commission',
    //     element: <ReportsCommissionPage/>
    // }
]

export default dashboardRouter;